import classnames from 'classnames'

import { Alert, AlertProps } from '@/components'

type MonitoringMonthlyReportAlertProps = AlertProps

export const MonitoringMonthlyReportAlert = ({
    className,
    ...props
}: MonitoringMonthlyReportAlertProps) =>
    <Alert
        type="custom"
        className={classnames(className, 'pl-0 pr-6 py-3 bg-white shadow-sm rounded-md')}
        {...props}
    >
        <div className="flex flex-row items-start lg:items-center gap-2 w-full justify-between">
            <div className="flex items-start lg:items-center grow gap-4">
                <div>
                    <svg
                        id="gradient-svg"
                        width="40"
                        height="40"
                        viewBox="-10 -9 38 38"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="stroke-slate-800 shadow-sm"
                    >
                        <path
                            d="m11.454 2.195 6.273 4.077c.222.144.332.216.413.312a.833.833 0 0 1 .157.29c.037.12.037.252.037.516v6.11c0 1.4 0 2.1-.273 2.635a2.5 2.5 0 0 1-1.092 1.092c-.535.273-1.235.273-2.635.273H5.667c-1.4 0-2.1 0-2.635-.273a2.5 2.5 0 0 1-1.093-1.092c-.272-.535-.272-1.235-.272-2.635V7.39c0-.264 0-.396.037-.516a.833.833 0 0 1 .157-.29c.08-.096.191-.168.413-.312l6.273-4.077m2.907 0c-.526-.342-.79-.513-1.073-.58a1.667 1.667 0 0 0-.762 0c-.283.067-.546.238-1.072.58m2.907 0 6.02 3.913c.286.186.43.279.48.397a.417.417 0 0 1 0 .323c-.05.118-.194.211-.48.398l-6.02 3.913c-.526.341-.79.513-1.073.579-.25.059-.511.059-.762 0-.283-.066-.546-.238-1.072-.58l-6.02-3.912c-.287-.187-.43-.28-.48-.398a.417.417 0 0 1 0-.323c.05-.118.193-.211.48-.397l6.02-3.913"
                            strokeWidth="1.667"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <defs>
                            <linearGradient
                                id="szrybseefb"
                                x1="21"
                                y1="15"
                                x2="25"
                                y2="15"
                                gradientUnits="userSpaceOnUse"
                            >
                                <stop stopColor="#FFB953"/>
                                <stop offset="1" stopColor="#FFD8A2"/>
                            </linearGradient>
                        </defs>
                    </svg>
                </div>
                <style>{`
                    #gradient-svg {
                        background: linear-gradient(-45deg, #fdfcfc, #c2c1c1, #fdfcfc, #c2c1c1);
                        background-size: 200% 100%;
                        animation: gradient 2s linear infinite;
                        border-radius: 10px;
                    }
                    @keyframes gradient {
                        0% { background-position: 0% 0%; }
                        100% { background-position: 203% 0%; }
                    }
                `}
                </style>
                <div className="flex items-center h-full text-gray-800">
                    <p className="font-body">
                        <span className="mr-1 font-semibold">
                            Stay on Top of Your Fleet Health!
                        </span>
                        Get your monthly report on critical alerts and claims. Ask your AM for more details.
                    </p>
                </div>
            </div>
        </div>
    </Alert>
